/* eslint-disable jsx-a11y/anchor-is-valid */
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  handleRenderStatusIndicator,
  capitalizeLetter,
  defaultDateDisplay,
  formatCurrency,
  truncateString,
  capitalizeFirstLetterOfEachWords,
} from "../../../../helpers";
import secondaryComponents from "../../../secondaryComponents";
import styles from "./TransactionDetailsV2.module.scss";
import primaryComponents from "../../../primaryComponents";
import useTransactionDetails from "./useTransactionDetails";
import Icon from "../../../../assets/icons";
import { useNavigate } from "react-router-dom";
import PrintSelect from "../PrintSelect";
import { EditIcon } from "../../../../assets/svgIcons";
import UpdateOrderDate from "../UpdateOrderDate";
import UpdateOrderTable from "../UpdateOrderTable";
import CustomerUpdate from "../../CustomerUpdate";
import InvoiceReadyModal from "../InvoiceReadyModal";

import {
  useAssignRiderToOrderMutation,
  useUpdateOrderPaymentMethodMutation,
  useUpdateOrderStatusMutation,
} from "../../../../hooks/api/mutations/useOrder";
import { useGetRiders } from "../../../../hooks/api/queries/useRiders";
import OrderCancel from "../../BillsWidget/orderCancel";
import { OrderReceipt } from "../../../printViews";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import SendToCustomerIcon from "../../../../assets/svgIcons/SendToCustomerIcon";
import MobilePOSIcon from "../../../../assets/svgIcons/MobilePOSIcon";
import PrintIcon from "../../../../assets/svgIcons/PrintIcon";
import { OrderItems } from "./OrderItems";
import { OrderNoteIcon } from "../../../../assets/svgIcons";
import { pathConstants } from "../../../../routes/pathContants";
import { useStoreCurrency } from "../../../../hooks/useStoreCurrency";
import { useCloseOtpAuthorizationPrompt } from "../../../../hooks/useCloseOtpAuthorizationPrompt";
import { orderColor } from "../../../../helpers/constants";
import { intergratedTerminalInfo } from "../../../../localdata/intergratedTerminalInfo";
import { BookingInfo } from "./BookingInfo";
import { RoutedModal } from "../../../common";
import { UpdateOrderNote } from "./UpdateOrderNote";

const TransactionDetailsV2 = ({
  orderId,
  isOrderFlow = true,
  resetView,
  viaSellMode = false,
  billWasUpdated = false,
  closeModal = () => {},
  setViaPos = () => {},
}) => {
  const {
    isPrintModal,
    isEditDate,
    isOrderCustomer,
    customerOrderDetails,
    showRejectionReason,
    isProcessingOrder,
    isOrderCancel,
    allowPrint,
    isPrinting,
    isLoading,
    orderDetails,
    isPrintingReturns,
    isEditTable,
    isUpdateNote,
    setIsUpdateNote,
    setAllowPrint,
    setIsOrderCancel,
    setShowRejectionReason,
    acceptOrRejectOrder,
    setCustomerOrderDetails,
    setIsOrderCustomer,
    setIsEditDate,
    setIsPrintModal,
    cancelCurrentOrder,
    printReceipt,
    // handlegenerateInvoice,
    handlePrintReturnsReceipt,
    // printPaymentsReceipt,
    // allowPaymentReceipt,
    isEditPaymentMethod,
    setIsEditPaymentMethod,
    setIsEditTable,
    isInvoiceModal,
    setIsInvoiceModal,
    isGeneratingInvoice,
  } = useTransactionDetails({
    orderId,
  });

  const { data: riders, isLoading: isFetchingRiders } = useGetRiders(
    orderDetails?.is_guest && !isLoading ? true : false,
  );
  const { updateStatus } = useUpdateOrderStatusMutation({});
  const { closeOtpAuthorizationPrompt } = useCloseOtpAuthorizationPrompt();
  const { updatePaymentMethod } = useUpdateOrderPaymentMethodMutation({
    onSuccess: closeOtpAuthorizationPrompt,
  });
  const { store_currency } = useStoreCurrency();
  const { assignRider } = useAssignRiderToOrderMutation({});

  const navigate = useNavigate();
  const isEditableMethod = ["cash", "card", "transfer"].includes(
    orderDetails?.payment_method,
  );

  const isInternalSource = orderDetails?.order_source === "INTERNAL";

  const isRestricted =
    ["raven", "interswitch"].includes(orderDetails?.payment_provider || "") &&
    ["card", "transfer"].includes(orderDetails?.payment_method || "");

  const canEditRestrictedMethod =
    isInternalSource && isEditableMethod && !isRestricted;
  const paymentProviderIcon =
    intergratedTerminalInfo?.[orderDetails?.payment_provider?.toUpperCase()]
      ?.icon;
  const showOrderTable =
    orderDetails?.table || orderDetails?.status === "PENDING";

  return (
    <>
      <div className={styles.transactionDetails}>
        {/* {!isOrderFlow ? (
          <FontAwesomeIcon
            onClick={closeModal}
            className="d-block ml-auto"
            icon="times"
            style={{ fontSize: "25px" }}
          />
        ) : null} */}

        {isOrderFlow ? (
          <div className={`${styles.actionContainer} flex-wrap`}>
            {orderDetails?.is_paid === false &&
            orderDetails?.status !== "CANCELED" ? (
              <primaryComponents.Button
                classNames={"btn btn--success"}
                style={{ height: "40px" }}
                onClick={() => {
                  closeModal();
                  navigate(
                    pathConstants.SELL_MODE_BILL_CHECKOUT({
                      store_id: orderDetails?.store?.id,
                      order_id: orderDetails?.id,
                    }),
                  );
                }}
              >
                Collect Payment
              </primaryComponents.Button>
            ) : null}

            {orderDetails?.payment_method === "bill" && (
              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Inventory Management"}
                permissionChildKey="can_edit_bill"
              >
                <primaryComponents.Button
                  classNames={"btn btn--outline"}
                  onClick={() => resetView("isOrderUpdate")}
                  style={{ height: "40px" }}
                >
                  <img
                    width={18}
                    src={Icon.editWrite}
                    className="mr-2"
                    alt=""
                  />
                  Update Bill
                </primaryComponents.Button>
              </secondaryComponents.NavigateWithPermission>
            )}

            {orderDetails &&
              orderDetails?.status !== "CANCELED" &&
              !orderDetails?.is_paid && (
                <primaryComponents.Button
                  classNames={"btn btn--outline"}
                  loadingText={"Cancelling..."}
                  onClick={() => setIsOrderCancel(true)}
                  style={{ height: "40px" }}
                >
                  <img
                    width={18}
                    src={Icon.xSquareCloseDelete}
                    className="mr-2"
                    alt=""
                  />
                  Cancel Bill
                </primaryComponents.Button>
              )}

            {orderDetails?.store?.allow_waybill &&
            orderDetails?.status !== "CANCELED" ? (
              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Inventory Management"}
                permissionChildKey="can_generate_waybill"
              >
                <primaryComponents.Button
                  onClick={() => resetView("isGenerateWaybill")}
                  classNames={"btn btn--primary"}
                  style={{ height: "40px" }}
                >
                  <img width={18} src={Icon.note} alt="" className="mr-1" />
                  <span>Generate Waybill</span>
                </primaryComponents.Button>
              </secondaryComponents.NavigateWithPermission>
            ) : null}

            {orderDetails?.store?.allow_prescription ? (
              <secondaryComponents.NavigateWithPermission
                permissionParentKey={"Inventory Management"}
                permissionChildKey="can_generate_prescription"
              >
                <primaryComponents.Button
                  onClick={() => resetView("isGeneratePescription")}
                  classNames={"btn btn--outline"}
                  style={{ height: "40px" }}
                >
                  <img
                    width={18}
                    src={Icon.printIcon}
                    alt=""
                    className="mr-1"
                  />
                  <span>Generate Prescription</span>
                </primaryComponents.Button>
              </secondaryComponents.NavigateWithPermission>
            ) : null}

            <primaryComponents.Button
              onClick={() => setIsInvoiceModal(true)}
              isDisabled={isGeneratingInvoice}
              isLoading={isGeneratingInvoice}
              loadingText={"Generating..."}
              classNames={"btn btn--primary"}
              style={{ height: "40px" }}
            >
              <img width={18} src={Icon.note} alt="" className="mr-2" />
              Generate Invoice
            </primaryComponents.Button>
          </div>
        ) : null}

        <secondaryComponents.LoaderHelper
          classNames={"mt-5"}
          isLoading={isLoading}
        >
          <div>
            <div
              className="d-flex justify-content-between align-items-center mt-3 mb-2"
              style={{ gap: "15px" }}
            >
              <h5 className="mb-0">Transaction Details</h5>

              {!orderDetails?.rejected_by &&
              !orderDetails?.accepted_by &&
              orderDetails?.is_guest ? (
                <div className={styles.actionContainer}>
                  <primaryComponents.Button
                    onClick={() =>
                      acceptOrRejectOrder({
                        isAccept: true,
                        rejectionReason: null,
                      })
                    }
                    classNames={"btn btn--primary smallBtn"}
                    isLoading={isProcessingOrder}
                    isDisabled={isProcessingOrder}
                    loadingText={"Accepting..."}
                  >
                    Accept Online Order
                  </primaryComponents.Button>
                  <primaryComponents.Button
                    onClick={() => setShowRejectionReason(true)}
                    classNames={"btn btn--outline-red smallBtn"}
                  >
                    Reject Online Order
                  </primaryComponents.Button>
                </div>
              ) : null}
            </div>

            <div className={styles.transactionDetails__column}>
              <section className={styles.tnxImportantDetails}>
                <div>
                  <p>Cashier Checkout: </p>

                  <div className="d-flex" style={{ gap: "3px" }}>
                    <p className="dark--text font-weight-bold d-flex items-center">
                      {orderDetails?.payment_method?.replace("_", " ") || "N/A"}
                    </p>
                    {canEditRestrictedMethod && (
                      <secondaryComponents.ToolTipV2
                        tipText="Edit payment method"
                        position="right"
                      >
                        <span
                          className="mr-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsEditPaymentMethod(true)}
                        >
                          <EditIcon />
                        </span>
                      </secondaryComponents.ToolTipV2>
                    )}
                  </div>
                </div>

                <div>
                  <p className="small-text-size">Payment Status: </p>
                  <span
                    className={`small-text-size ${
                      !orderDetails?.is_paid
                        ? "error--squared"
                        : "success--squared"
                    }`}
                    style={{ width: "fit-content" }}
                  >
                    {" "}
                    {orderDetails?.is_paid ? "PAID" : "NOT PAID"}
                  </span>
                </div>
                {orderDetails?.is_guest ? (
                  <>
                    <div>
                      <p>Rider: </p>
                      {!isFetchingRiders ? (
                        <div style={{ width: "160px" }}>
                          <primaryComponents.SelectField
                            options={riders?.data}
                            value={
                              riders?.data?.find(
                                (rider) =>
                                  rider?.id ===
                                  orderDetails?.dispatch_rider?.id,
                              )?.name || "Assign Rider"
                            }
                            placeholder={"Assign Rider"}
                            floatError={false}
                            nameKey={"name"}
                            idKey={"id"}
                            onChange={(value) => {
                              assignRider(orderDetails?.id, value);
                            }}
                            isDisabled={!orderDetails?.delivery_address}
                            minHeight="40px"
                          />
                        </div>
                      ) : null}
                    </div>
                    <div>
                      <p>Order Status: </p>
                      <primaryComponents.FancySelectField
                        placeholder={"Update status"}
                        options={[
                          {
                            name: "Order Ready",
                            id: "ORDER_READY",
                            bgColor: "#15112d",
                          },
                          {
                            name: "Shipped",
                            id: "SHIPPED",
                            bgColor: "#F7AD3C",
                          },
                          {
                            name: "Delivered",
                            id: "DELIVERED",
                            bgColor: "#7647ee",
                          },
                          {
                            name: "Completed",
                            id: "COMPLETED",
                            bgColor: "#19AE57",
                          },
                          {
                            name: "Scheduled",
                            id: "SCHEDULED",
                            bgColor: "#F2EDFE",
                            color: "#000",
                          },
                          {
                            name: "Returned",
                            id: "RETURNED",
                            bgColor: "#ff9292",
                          },
                        ]}
                        nameKey={"name"}
                        idKey={"id"}
                        bgKey={"bgColor"}
                        colorKey={"color"}
                        style={{ height: "40px" }}
                        selectedItem={{
                          label: capitalizeLetter(
                            orderDetails?.status?.replace("_", " "),
                          ),
                          bgColor: orderColor[orderDetails?.status]?.bgColor,
                          color: orderColor[orderDetails?.status]?.color,
                        }}
                        onChange={(item) => {
                          updateStatus(orderDetails?.id, item?.value);
                        }}
                      />
                    </div>
                    {orderDetails?.can_be_scheduled ? (
                      <div>
                        <p>Expected Delivery Date/Time:</p>
                        <h6 className="error--text">
                          {orderDetails?.expected_delivery_date}
                        </h6>
                      </div>
                    ) : null}
                  </>
                ) : null}
              </section>
              {orderDetails?.payment_method === "split" ? (
                <section
                  className={`${globalStyles.cardWithBorder} w-100`}
                  style={{ background: "#F3F3F3" }}
                >
                  <p className="dark--text small-text-size font-weight-bold">
                    Split Details
                  </p>
                  <hr style={{ marginLeft: "-15px", marginRight: "-15px" }} />

                  <div
                    className={`${globalStyles.cardWithBorder} w-100`}
                    style={{ background: "#fff", padding: "1px" }}
                  >
                    <div className={globalStyles.gridContainer}>
                      {Object.entries(orderDetails?.split_mode || {})
                        .filter(([_, value]) => Number(value) !== 0)
                        .map(([key, value], idx) => (
                          <div key={idx}>
                            <p className="small-text-size">
                              {truncateString(
                                key.replace("_", " ").charAt(0).toUpperCase() +
                                  key.replace("_", " ").slice(1),
                                20,
                              )}
                            </p>
                            <p className="smallest-text-size dark--text font-weight-bold mt-2">
                              {formatCurrency({
                                value: value.toFixed(2),
                                currencyCode: store_currency,
                                decimal: 0,
                              })}
                            </p>
                          </div>
                        ))}
                      <div>
                        <p className="smallest-text-size font-weight-bold">
                          Total
                        </p>
                        <p className="smallest-text-size dark--text mt-2 font-weight-bold">
                          {formatCurrency({
                            value: Object.values(orderDetails?.split_mode || {})
                              .reduce((acc, curr) => acc + Number(curr), 0)
                              .toFixed(2),
                            currencyCode: store_currency,
                            decimal: 0,
                          })}
                        </p>
                      </div>
                    </div>
                  </div>
                </section>
              ) : null}

              <div>
                <p className="small-text-size">Order ID:</p>
                <p className="dark--text">{orderDetails?.id}</p>
              </div>
              {orderDetails?.queue_number ? (
                <div>
                  <p className="small-text-size">Queue Number:</p>
                  <p className="dark--text">
                    {orderDetails?.queue_number || "N/A"}
                  </p>
                </div>
              ) : null}
              <div>
                <p className="d-flex">
                  {!viaSellMode ? (
                    <secondaryComponents.NavigateWithPermission
                      permissionParentKey={"Inventory Management"}
                      permissionChildKey="can_update_order_date"
                    >
                      <secondaryComponents.ToolTipV2 tipText="Edit Date">
                        <span
                          className="mr-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsEditDate(true)}
                        >
                          <EditIcon />
                        </span>
                      </secondaryComponents.ToolTipV2>
                    </secondaryComponents.NavigateWithPermission>
                  ) : null}
                  <p className="small-text-size">Order Date:</p>
                </p>

                <p className="dark--text">
                  {orderDetails?.order_dates?.length > 0
                    ? defaultDateDisplay(
                        orderDetails?.order_dates?.[
                          orderDetails?.order_dates?.length - 1
                        ],
                      )
                    : defaultDateDisplay(orderDetails?.created_at)}
                </p>
              </div>
              <div>
                <p className="small-text-size">Payment Ref:</p>
                {orderDetails?.trx_receipt_link ? (
                  <a
                    className="dark--text"
                    href={orderDetails?.trx_receipt_link || ""}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {orderDetails?.trx_reference || "N/A"}
                  </a>
                ) : (
                  <p>{orderDetails?.trx_reference || "N/A"}</p>
                )}
              </div>
              <div>
                <p className="small-text-size">Order Status:</p>
                <span
                  style={{
                    ...handleRenderStatusIndicator(orderDetails?.status),
                  }}
                  className="success--squared"
                >
                  {orderDetails?.status?.replace("_", " ")}
                </span>
              </div>
              <div>
                <p className="small-text-size">Delivery Type:</p>
                <p className="dark--text">
                  {orderDetails?.order_type === "DINE_IN" ||
                  orderDetails?.order_type === "TAKE_OUT"
                    ? "PICK UP"
                    : "DELIVERY"}
                </p>
              </div>
              <div>
                <p className="small-text-size">Cashier:</p>
                <p className="dark--text">
                  {orderDetails?.cashier?.first_name || "N/A"}
                </p>
              </div>
              <div>
                <p className="d-flex align-items-center">
                  <secondaryComponents.NavigateWithPermission
                    permissionParentKey={"Inventory Management"}
                  >
                    <secondaryComponents.ToolTipV2 tipText="Update Customer Details">
                      <span
                        className="mr-1"
                        style={{ cursor: "pointer" }}
                        onClick={() => setIsOrderCustomer(true)}
                      >
                        <EditIcon />
                      </span>
                    </secondaryComponents.ToolTipV2>
                  </secondaryComponents.NavigateWithPermission>
                  <span className="small-text-size">Customer:</span>
                </p>
                <p className="dark--text">
                  {orderDetails?.customer?.full_name || "N/A"}
                </p>
              </div>
              <div>
                <p className="small-text-size">Store Name:</p>
                <p className="dark--text">
                  {orderDetails?.store?.name || "N/A"}
                </p>
              </div>
              {orderDetails?.payment_provider ? (
                <div>
                  <p className="small-text-size">Payment Provider:</p>
                  <p className="d-flex align-items-center dark--text">
                    {paymentProviderIcon ? (
                      <span className="mr-2">{paymentProviderIcon}</span>
                    ) : null}
                    {capitalizeFirstLetterOfEachWords(
                      orderDetails?.payment_provider || "",
                    )}
                  </p>
                </div>
              ) : null}
              {showOrderTable && (
                <div>
                  <p className="d-flex align-items-center">
                    {orderDetails?.status === "PENDING" ? (
                      <secondaryComponents.ToolTipV2
                        tipText="Update Order Table"
                        position="right"
                      >
                        <span
                          className="mr-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsEditTable(true)}
                        >
                          <EditIcon />
                        </span>
                      </secondaryComponents.ToolTipV2>
                    ) : null}
                    <span className="small-text-size">Table:</span>
                  </p>
                  <p className="dark--text">
                    {orderDetails?.table?.name || "N/A"}
                  </p>
                </div>
              )}
              {orderDetails?.has_returned_items && (
                <div>
                  <p className="small-text-size">Return Amount:</p>
                  <p className="dark--text">
                    {formatCurrency({
                      value: orderDetails?.total_returned_amount,
                      currencyCode: orderDetails?.store?.currency_code,
                    })}
                  </p>
                </div>
              )}
              {orderDetails?.delivery_address && (
                <div>
                  <p className="small-text-size">Delivery Address:</p>
                  <p className="dark--text">
                    {`${orderDetails?.delivery_address?.address} ${
                      orderDetails?.delivery_address?.zipcode || ""
                    } ${orderDetails?.delivery_address?.city || ""} ${
                      orderDetails?.delivery_address?.state
                    }, ${orderDetails?.delivery_address?.country}` || "N/A"}
                  </p>
                </div>
              )}
              {orderDetails?.dispatch_rider ? (
                <div>
                  <p className="small-text-size">Dispatch Rider:</p>
                  <p className="dark--text">
                    {orderDetails?.dispatch_rider?.name} <br />(
                    {orderDetails?.dispatch_rider?.phone_code}){" "}
                    {orderDetails?.dispatch_rider?.phone_number}
                  </p>
                </div>
              ) : null}
              {orderDetails?.waybills?.length > 0 ? (
                <div>
                  <p className="small-text-size">Waybills</p>
                  <a
                    onClick={() => {
                      resetView("isWaybillDetails");
                    }}
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    className="small-text-size purple--text font-weight-semibold"
                  >
                    View Waybills
                  </a>
                </div>
              ) : null}
              {orderDetails?.prescriptions?.length > 0 ? (
                <div>
                  <p className="small-text-size">Prescriptions</p>
                  <a
                    onClick={() => {
                      resetView("isPrescriptionDetails");
                    }}
                    style={{ textDecoration: "underline", cursor: "pointer" }}
                    className="small-text-size purple--text font-weight-semibold"
                  >
                    View Prescriptions
                  </a>
                </div>
              ) : null}

              {orderDetails?.intervention_types?.length ? (
                <div>
                  <p className="small-text-size">Intervention Type:</p>
                  <p className="dark--text">
                    {orderDetails?.intervention_types
                      ?.map((item) => item?.name)
                      ?.join(", ")}
                  </p>
                </div>
              ) : null}

              {orderDetails?.patient_indications?.length ? (
                <div>
                  <p className="small-text-size">Patient Indication:</p>
                  <p className="dark--text">
                    {orderDetails?.patient_indications
                      ?.map((item) => item?.name)
                      ?.join(", ")}
                  </p>
                </div>
              ) : null}

              <div>
                <p className="d-flex align-items-center">
                  <secondaryComponents.ToolTipV2
                    tipText="Update Order Note"
                    position="right"
                  >
                    <span
                      className="mr-1"
                      style={{ cursor: "pointer" }}
                      onClick={() => setIsUpdateNote(true)}
                    >
                      <EditIcon />
                    </span>
                  </secondaryComponents.ToolTipV2>

                  <span className="small-text-size">Note:</span>
                </p>
                <p className="dark--text">{orderDetails?.notes || "N/A"}</p>
              </div>
            </div>
          </div>

          {/* {orderDetails?.payment_method === "split" && (
              <>
                <h5 className="mt-4 mb-3">Split Payment</h5>
                <div className={styles.orderDetails}>
                  <p>MODE</p>
                  <h6 className="text-left">AMOUNT</h6>
                </div>
                {Object.entries(orderDetails?.split_mode).map(
                  ([key, value]) => (
                    <div key={key} className={styles.orderDetails}>
                      <p>{key}</p>
                      <p
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        {formatCurrency({
                          value,
                          currencyCode: store_currency,
                        })}
                      </p>
                    </div>
                  ),
                )}
              </>
            )} */}

          <BookingInfo orderItems={orderDetails?.order_items} />

          <OrderItems orderDetails={orderDetails} />

          <div className={styles.summaryCover}>
            {/* {orderDetails?.notes && (
              <div
                className={`${globalStyles.cardWithBorder} white w-100`}
                style={{ padding: "5px 10px 1px 10px", height: "fit-content" }}
              >
                <primaryComponents.TextArea
                  value={orderDetails?.notes}
                  readonly={true}
                  label={
                    <span className="d-flex align-items-end">
                      <OrderNoteIcon color={"#7647EE"} width="20" height="20" />{" "}
                      <span className="ml-2">Order Note</span>
                    </span>
                  }
                  floatError={false}
                  isDisabled={true}
                />
              </div>
            )} */}

            {orderDetails?.sync_process_error &&
              typeof orderDetails?.sync_process_error === "object" &&
              Object.keys(orderDetails.sync_process_error).length > 0 && (
                <div
                  className={`${globalStyles.cardWithBorder} white w-100`}
                  style={{
                    padding: "5px 10px 1px 10px",
                    height: "fit-content",
                  }}
                >
                  <primaryComponents.TextArea
                    value={JSON.stringify(
                      orderDetails.sync_process_error,
                      null,
                      2,
                    )}
                    readonly={true}
                    label={
                      <span className="d-flex align-items-end">
                        <OrderNoteIcon color="#7647EE" width="20" height="20" />
                        <span className="ml-2">Sync Error</span>
                      </span>
                    }
                    floatError={false}
                    isDisabled={true}
                  />
                </div>
              )}
          </div>
        </secondaryComponents.LoaderHelper>

        {isOrderFlow ? (
          <div className={styles.transactionDetails__bottom}>
            {/* {orderDetails?.rrn ? (
              <primaryComponents.Button
                classNames={"btn btn--primary cover"}
                isDisabled={allowPaymentReceipt}
                isLoading={allowPaymentReceipt}
                loadingText={"Proccessing..."}
                onClick={printPaymentsReceipt}
                style={{ height: "55px" }}
              >
                <span className="d-flex align-items-center">
                  <PrintIcon />
                  <span className="ml-2">Print Payment Receipt</span>
                </span>
              </primaryComponents.Button>
            ) : null} */}
            <primaryComponents.Button
              classNames={"btn btn--green cover"}
              isDisabled={isPrinting || allowPrint}
              isLoading={isPrinting || allowPrint}
              loadingText={"Proccessing..."}
              onClick={() => {
                if (orderDetails?.section_items_status === "NOT_SENT") {
                  if (!billWasUpdated) printReceipt();
                  else setIsPrintModal(true);
                } else {
                  setViaPos(false);
                  resetView("isPrintOnDevice");
                }
              }}
              style={{ height: "55px" }}
            >
              <span className="d-flex align-items-center">
                <PrintIcon />
                <span className="ml-2">Print Sales Receipt</span>
              </span>
            </primaryComponents.Button>

            {orderDetails?.has_returned_items && (
              <primaryComponents.Button
                classNames={"btn btn--primary cover"}
                isDisabled={isPrintingReturns}
                isLoading={isPrintingReturns}
                loadingText={"Proccessing..."}
                onClick={() => handlePrintReturnsReceipt()}
                style={{ height: "55px" }}
              >
                <span className="d-flex align-items-center">
                  <PrintIcon />
                  <span className="ml-2">Print Returns Receipt</span>
                </span>
              </primaryComponents.Button>
            )}

            <secondaryComponents.CountryItemPermission>
              <secondaryComponents.NavigateWithPermission permissionParentKey="Inventory Management">
                <primaryComponents.Button
                  classNames={"btn btn--outline cover"}
                  onClick={() => {
                    if (orderDetails?.section_items_status === "NOT_SENT")
                      resetView("isTerminal");
                    else {
                      setViaPos(true);
                      resetView("isPrintOnDevice");
                    }
                  }}
                  style={{ height: "55px" }}
                >
                  <span className="d-flex align-items-center">
                    <MobilePOSIcon />
                    <span className="ml-1">Print on POS</span>
                  </span>
                </primaryComponents.Button>
              </secondaryComponents.NavigateWithPermission>
            </secondaryComponents.CountryItemPermission>

            <secondaryComponents.ToolTipV2
              tipText="Send To Customer"
              position="left"
            >
              <primaryComponents.Button
                classNames={"btn btn--outline"}
                onClick={() => {
                  resetView("isSendReceipt");
                }}
                style={{ height: "55px", width: "120px", padding: "0 10px" }}
              >
                <SendToCustomerIcon />
              </primaryComponents.Button>
            </secondaryComponents.ToolTipV2>
          </div>
        ) : null}
      </div>

      {/* print select */}
      <secondaryComponents.Modal
        isActive={isPrintModal}
        closeModal={() => setIsPrintModal(false)}
        width={500}
      >
        <PrintSelect
          setIsPrintModal={setIsPrintModal}
          printReceipt={printReceipt}
        />
      </secondaryComponents.Modal>

      {/* edit order date */}
      <secondaryComponents.Modal
        isActive={isEditDate}
        closeModal={() => setIsEditDate(false)}
        width={500}
      >
        <UpdateOrderDate
          orderId={orderDetails?.id}
          closeModal={() => setIsEditDate(false)}
        />
      </secondaryComponents.Modal>

      {/* edit table */}
      <secondaryComponents.Modal
        isActive={isEditTable}
        closeModal={() => setIsEditTable(false)}
        width={900}
      >
        <UpdateOrderTable
          orderId={orderDetails?.id}
          storeId={orderDetails?.store?.id}
          orderTableId={orderDetails?.table?.id}
          closeModal={() => setIsEditTable(false)}
        />
      </secondaryComponents.Modal>

      {/* Update order note */}
      <RoutedModal
        width={550}
        isActive={isUpdateNote}
        closeModal={() => setIsUpdateNote(false)}
        headerTitle="Update Order Note"
        style={{ height: "auto" }}
      >
        <UpdateOrderNote
          orderDetails={orderDetails}
          closeModal={() => setIsUpdateNote(false)}
        />
      </RoutedModal>

      {/* update customer details */}
      <secondaryComponents.Modal
        isActive={isOrderCustomer}
        closeModal={() => setIsOrderCustomer(false)}
        width={580}
      >
        <CustomerUpdate
          closeWidget={() => setIsOrderCustomer(false)}
          customerOrderDetails={customerOrderDetails}
          setCustomerOrderDetails={setCustomerOrderDetails}
          orderId={orderDetails?.id}
        />
      </secondaryComponents.Modal>

      {/* edit payment method */}
      <secondaryComponents.Modal
        isActive={isEditPaymentMethod}
        closeModal={() => setIsEditPaymentMethod(false)}
        width={500}
      >
        <secondaryComponents.EditPaymentMethod
          orderDetails={orderDetails}
          closeModal={() => setIsEditPaymentMethod(false)}
          updatePaymentMethod={updatePaymentMethod}
        />
      </secondaryComponents.Modal>

      {/* accept order */}
      <secondaryComponents.Modal
        width={500}
        isActive={showRejectionReason}
        closeModal={() => setShowRejectionReason(false)}
      >
        <secondaryComponents.RejectOrderPop
          onSubmit={acceptOrRejectOrder}
          closeModal={() => setShowRejectionReason(false)}
          isProcessingOrder={isProcessingOrder}
        />
      </secondaryComponents.Modal>

      <secondaryComponents.Modal
        isActive={isOrderCancel}
        closeModal={() => setIsOrderCancel(false)}
        width={500}
      >
        <OrderCancel
          closeWidget={() => setIsOrderCancel(false)}
          orderDetails={orderDetails}
          cancelCurrentOrder={cancelCurrentOrder}
        />
      </secondaryComponents.Modal>

      {/* Invoice ready modal */}
      <secondaryComponents.Modal
        isActive={isInvoiceModal}
        closeModal={() => setIsInvoiceModal(false)}
        width={500}
      >
        <InvoiceReadyModal
          orderDetails={orderDetails}
          invoiceUrl={orderDetails?.receipt_url || orderDetails?.invoice_url}
          closeModal={() => setIsInvoiceModal(false)}
        />
      </secondaryComponents.Modal>

      {allowPrint ? (
        <OrderReceipt
          orderId={orderId}
          closePrint={() => setAllowPrint(false)}
        />
      ) : null}
    </>
  );
};

export default TransactionDetailsV2;
